module.exports = __webpack_public_path__ + "media/images/team/default-male-507221f5483f800713d52836920cde2a.png";